import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: Array<ClassValue>) {
  const mergedClassNames = twMerge(clsx(inputs));

  if (
    ['border-input', 'border-transparent'].some((className) =>
      mergedClassNames.includes(className)
    )
  ) {
    return mergedClassNames.replace('design-system', '').trim();
  }

  const uniqueClassNames = new Set([
    ...mergedClassNames.split(' '),
    'design-system'
  ]);

  return Array.from(uniqueClassNames).join(' ').trim();
}
